<template>
  <div class="invoice-statistics">
    <div class="top-wrp">
      <div class="top-wrp-content">
        <van-row class='tab-wrap'>
          <van-col span="12">
            <div class="title">累计销项金额：</div>
          </van-col>
          <van-col span="12">
            <div class="tab-btn" style="float: right">
              <span :class="statisticPeriod === 'month' ? 'active' : ''" @click="changeStats('month')">当月</span>
              <span :class="statisticPeriod === 'season' ? 'active' : ''" @click="changeStats('season')">季度</span>
              <span :class="statisticPeriod === 'annual' ? 'active' : ''" @click="changeStats('annual')">年度</span>
            </div>
          </van-col>
        </van-row>
        <div class="moneyAll">{{convertNumber(stats.totalAmount)}}</div>
        <div class="statistics">
          <div class="statistics-item">
            <span>已开发票：</span>
            <span class="num">{{Number(stats.totalNum)}}</span>
            <span>张</span>
          </div>
          <div class="statistics-item-second">
            <span>销项税额：</span>
            <span class="num">{{Number(stats.totalTaxAmount)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="list-wrp">
      <van-tabs style="height: 100%" v-model="active" @change="getList">
        <van-tab class="pull-wrp" name='0' :title="`未寄送(${dataSource.apply.unSendQuantity})`">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <InvoiceCard
                v-for="(invoice) in invoiceList"
                :key="invoice.id"
                :invoice="invoice"
                :withGetType="false"
                :btnList="['preview', 'detail']"
              />
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab class="pull-wrp" name='1' :title="`未签收(${dataSource.apply.unSignedQuantity})`">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <InvoiceCard
                v-for="(invoice) in invoiceList"
                :key="invoice.id"
                :invoice="invoice"
                :withGetType="false"
                :btnList="['express', 'preview', 'detail']"
              />
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab class="pull-wrp" name='all' title="全部发票">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <InvoiceCard
                v-for="(invoice) in invoiceList"
                :key="invoice.id"
                :invoice="invoice"
                :btnList="invoice.logisticsFlag === 1 && invoice.logisticsStatus ? ['express', 'preview', 'detail'] : ['preview', 'detail']"
              />
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Field,
  Row,
  Col,
  DropdownMenu,
  DropdownItem,
  Button,
  Tab,
  Tabs,
  Notify,
  List,
  PullRefresh
} from 'vant'

import {
  ConvertNumber
} from '@utils/basicUtil'
import { invoiceRequest } from '@services'

import InvoiceCard from '@components/InvoiceCard'

export default {
  data: () => ({
    statisticPeriod: 'month',
    active: 'all',
    invoiceList: [],
    dataSource: {
      apply: {
        unSendQuantity: 0,
        unSignedQuantity: 0
      }
    },
    stats: {
      totalAmount: 0,
      totalNum: 0,
      totalTaxAmount: 0
    },
    query: {
      size: 25,
      current: 1
    },
    loading: false,
    refreshing: false,
    finished: false
  }),
  mounted () {
    this.getStatistics()
    this.getList()
  },
  methods: {
    changeStats (period) {
      this.statisticPeriod = period
      if (period === 'month') {
        this.stats = this.dataSource.currMonthStatistics
      }
      if (period === 'season') {
        this.stats = this.dataSource.quarterStatistics
      }
      if (period === 'annual') {
        this.stats = this.dataSource.yearStatistics
      }
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    getList () {
      this.finished = false
      this.invoiceList = []
      this.query.current = 1
      this.getStatsList()
    },
    async getStatsList () {
      // 0未寄送 1已寄送 2已签收
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        logisticsStatus: this.active === 'all' ? undefined : Number(this.active),
        ...this.query
      }
      const data = await invoiceRequest.statistics.getStatsList(postData)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        Notify({ type: 'danger', message: data.message })
        this.finished = true
      }
      this.loading = false
    },
    async getStatistics () {
      const data = await invoiceRequest.statistics.getStatistics({})
      if (data.success) {
        this.dataSource = data.result
        this.changeStats('month')
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    onLoad () {
      this.query.current++
      this.getStatsList()
    },
    onRefresh () {
      this.finished = false
      this.query = {
        current: 1,
        size: 25
      }
      this.getList()
    }
  },
  components: {
    InvoiceCard,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
